jQuery.fn.topLink = function(settings) {
    settings = $.extend({
        min: 1,
        fadeSpeed: 200,
        scrollSpeed: 500,
    }, settings);

    return this.each(function() {
        let el = $(this);
        el.hide();

        el.on('click', function() {
            $('html, body').animate({ scrollTop: 0 }, settings.scrollSpeed);
        });

        $(window).scroll(function() {
            if ($(window).scrollTop() >= settings.min) {
                el.fadeIn(settings.fadeSpeed);
            } else {
                el.fadeOut(settings.fadeSpeed);
            }
        });
    });
};